

  
const content = `# Release Notes for Version 2.1.57
Version 2.1.57 is released with a new feature named OnData SecureFile to protect all types of unstructured data in files or documents. The documents are strongly
encrypted at all times and dynamically made usable for authorized users only. OnData SecureFile protects the confidential and regulated data in documents 
against both external and internal threats. Data breaches are prevented even when the network security controls are compromised. Below is a summary of the 
OnData SecureFile features:  
* Protect any types of files at all times (at-rest, in-transit, and at-runtime).  
* Integrate with Windows Explorer context menus to conveniently encrypt/decrypt files.  
* Integrate with Identity Provider to leverage MFA capability for user authentication.  
* Enforce data access roles so that only authorized users can access the protected files.  
* Track all file instances, activities, and locations.  
* Provide detailed audit logs on who has access which file where and when.  
  
OnData SecureFile currently supports the Windows operating systems (Windows 10 and Windows 11) only, with other major operating systems, such as MacOS and 
Linux, on the product roadmap. If you are using OnData to protect the confidential and regulated data in your databases, you may also consider to use OnData 
SecureFile to protect such kind of data in all sorts of documents as well. The OnData SecureFile product is very easy to use. Please refer to the 
[**OnData SecureFile**](reference_doc#how-to_guides/securefile/install_securefile) page on how to install and use the product.  
  `
  
export default content;
